import React, { useState } from "react";
import AlertDialog from "../../../../../components/alertDialog";
import i18n from "~/i18n";

export default function DeletePromptDialog({
  promptToDelete,
  isOpen,
  onSubmit,
  ...rest
}) {
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit() {
    setSubmitting(true);

    try {
      await onSubmit(promptToDelete);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AlertDialog
      open={isOpen}
      title={i18n.t("chat:channel.chat.prompts.remove.header")}
      description={i18n.t("chat:channel.chat.prompts.remove.desc", { name: promptToDelete?.name })}
      ctaText={i18n.t("chat:channel.chat.prompts.remove.confirm")}
      submitting={submitting}
      onCtaClick={handleSubmit}
      {...rest}
    />
  );
}
